/**
 * Map of events that our app sends to external clients
 */
export const BTO_EMITERS = {
  APP_LOADED: 'btoAppLoaded',
  BET_PLACED: 'betPlaced',
  CASHED_OUT: 'cashedOut',
};

/**
 * Map of events that our app listents to from external clients
 */
export const BTO_LISTENERS = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  CHANGE_LANG: 'changeLanguage',
  MYBETS: 'openMybets',
};